import type { Layout } from '@ghostscreen/contracts';
import { useTranslation } from 'react-i18next';
import { layoutSummary } from './layoutFormat';

type LayoutsListCardProps = {
  layouts: Layout[];
  playlistName: (playlistId: string | null) => string | null;
  onOpen: (layoutId: string) => void;
};

export function LayoutsListCard({ layouts, playlistName, onOpen }: LayoutsListCardProps) {
  const { t } = useTranslation('layouts');
  return (
    <section
      className="w-full min-w-0 self-stretch overflow-hidden rounded-[14px] border"
      style={{
        background: 'var(--gs-panel)',
        borderColor: 'var(--gs-line)',
        width: '100%',
        maxWidth: '100%',
        boxSizing: 'border-box',
      }}
    >
      <div
        className="border-b px-5 py-[18px] text-base font-bold"
        style={{ borderColor: 'var(--gs-line)' }}
      >
        {t('list.title')}
      </div>
      {layouts.length === 0 ? (
        <div className="px-5 py-[22px] text-sm" style={{ color: 'var(--gs-muted)' }}>
          {t('list.empty')}
        </div>
      ) : (
        layouts.map((layout) => (
          <button
            key={layout.id}
            type="button"
            onClick={() => onOpen(layout.id)}
            className="flex w-full flex-wrap items-center gap-x-5 gap-y-2.5 border-b px-5 py-4 text-start last:border-b-0"
            style={{
              borderColor: 'var(--gs-line)',
              fontFamily: 'inherit',
              color: 'var(--gs-ink)',
            }}
            onMouseEnter={(event) => {
              event.currentTarget.style.background = 'var(--gs-panel2)';
            }}
            onMouseLeave={(event) => {
              event.currentTarget.style.background = 'transparent';
            }}
          >
            <span className="flex min-w-[180px] flex-1 flex-col gap-1">
              <span className="text-[15.5px] font-bold">{layout.name || t('list.untitled')}</span>
              <span className="text-[12.5px]" style={{ color: 'var(--gs-muted)' }}>
                {layoutSummary(layout, playlistName)}
              </span>
            </span>
            <span
              className="rounded-full border px-[11px] py-[5px] text-[12.5px] font-semibold"
              style={{
                color: 'var(--gs-ink2)',
                background: 'var(--gs-panel2)',
                borderColor: 'var(--gs-line)',
              }}
            >
              {t(`templates.${layout.template}.name`)}
            </span>
            <span className="text-[13px] font-bold" style={{ color: 'var(--gs-accent)' }}>
              {t('list.edit')}
            </span>
          </button>
        ))
      )}
    </section>
  );
}
